import { useTranslation } from 'react-i18next';
import { getColumns } from '../../util';
import AccessRequestTableOthers from 'components/AccessRequests/Tables/Others';
import { useSelector } from 'react-redux';
import { getDashboardsAccess } from 'store/authentication/selectors';

const DashboardSettingsAccessRequests = (props) => {
  const { t } = useTranslation();

  const { edit: canEdit, remove: canDelete } = useSelector(getDashboardsAccess);

  return (
    <AccessRequestTableOthers
      {...props}
      getColumns={getColumns}
      entitySingular={t('Dashboard')}
      entityPlural={t('Dashboards')}
      canEdit={canEdit}
      canDelete={canDelete}
    />
  );
};

export default DashboardSettingsAccessRequests;
